import { Component, OnInit } from '@angular/core';
import { VigenciasSolicitudes, ValidityEmployees } from '../../_models/vigencias';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ActivatedRoute, Router } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';
import { ValidityEmployeesService } from '../../_services/vigencias-tercero.service';
import { ValidityRequestsService } from '../../_services/vigencias-requisitos.service';
import { ControlSection, Funcionalidades } from '../../_enums/enum';
import { forkJoin } from 'rxjs';
import { RolFuncionalitiesServices } from '../../_services/rol-funcionalidad.service';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { AdministradorDocumentoService } from '../../_services/administrador-documento.service';
import { AdministradorDocumento } from '../../_models/administrador-documento';

@Component({
  selector: 'app-vigencias-apl',
  templateUrl: './vigencias-apl.component.html',
  styleUrls: ['./vigencias-apl.component.scss']
})
export class VigenciasAplComponent implements OnInit {

    listValidityDocuments: AdministradorDocumento[] = [];
    listValidityEmployees: ValidityEmployees[] = [];
    listValidityRequests: VigenciasSolicitudes[] = [];

    permissionVIGSOL: boolean = false;
    permissionVIGTER: boolean = false;
    permissionADMDOC: boolean = false;
    private rolesUsuario: any;
    private usuarioLogueado: any;
    private jwtHelper: JwtHelperService = new JwtHelperService();
    loading: boolean = false;
    activeTabIndex: number = 0;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private validityEmployeesService: ValidityEmployeesService,
        private validityRequestsService: ValidityRequestsService,
        private cdr: ChangeDetectorRef,
        private rolFuncionalitiesService: RolFuncionalitiesServices,
        private autServicio: AutenticacionService,
        private administradorDocumentoService: AdministradorDocumentoService
    ) {
        this.loading = true;
        this.route.queryParams.subscribe(params => {
           if (params['tab']) {
             this.activeTabIndex = +params['tab'];
             setTimeout(() => {
              this.router.navigate([], {
                relativeTo: this.route,
                queryParams: {},
                replaceUrl: true,
              });
            }, 0);
           }
           const token = localStorage.getItem('token');
           if (token !== null) {
              this.usuarioLogueado = this.jwtHelper.decodeToken(token);
              this.rolesUsuario = this.usuarioLogueado.authorities;
           }
         });
     }

    async ngOnInit(): Promise<void> {
        try {
            this.initialLoad();
            await this.validityPermissions();
         } finally {
            setTimeout(() => {
               this.cdr.detectChanges();
            });
         }
    }

    initialLoad() {
        this.loading = true;
        forkJoin([
           this.validityEmployeesService.getAll(),
           this.administradorDocumentoService.getAll(),
           this.validityRequestsService.getAll()
        ]).subscribe({
           next: ([employees, documents, requests]) => {
              this.listValidityEmployees = employees;
              this.listValidityDocuments = documents.sort((a, b) => a.orden - b.orden);
              this.listValidityRequests = requests;
              this.loading = false;
              this.cdr.detectChanges();
           },
           error: (error) => {
              console.error('Error loading data:', error);
              this.loading = false;
              this.cdr.detectChanges();
           }
        });
     }
  
     async validityPermissions() {
        try {
           const permisos = await this.rolFuncionalitiesService.seccionesControles(Funcionalidades.VIGENCIAS, this.autServicio.obtenerIdUsuarioLogueado()).toPromise();
           this.permissionVIGSOL = permisos?.secciones.some(p => p.codigoSeccion === ControlSection.VIGSOL);
           this.permissionVIGTER = permisos?.secciones.some(p => p.codigoSeccion === ControlSection.VIGTER);
           this.permissionADMDOC = permisos?.secciones.some(p => p.codigoSeccion === ControlSection.ADMDOC);
           this.cdr.detectChanges();
        } catch (error) {
           console.error('Error en validityPermissions:', error);
           this.loading = false;
           this.cdr.detectChanges();
        }
     }
  
     onTabChange(event: any) {
        this.activeTabIndex = event.index;
     }
}